import { Video } from '@/lib/apiTypes';
import { AudioDescriptionFile } from '@ntrinternet/ntr-ui';
import { encode } from 'js-base64';
import { useEffect, useState } from 'react';

const useVideo = ({ video }: { video?: Video }) => {
	const [audioDescriptionFile, setAudioDescriptionFile] =
		useState<AudioDescriptionFile>({
			audioDescription: [],
		});
	const [subtitlesBase64, setSubtitlesBase64] = useState<string>('');
	const [isError, setIsError] = useState<boolean>(false);

	useEffect(() => {
		if (!video) return;

		// Download the audio description file and parse the JSON
		const aDUrl = `${video.audioDescription.data?.attributes?.url}?v=2`;
		if (aDUrl)
			fetch(aDUrl)
				.then((response) => response.json())
				.then((data) => {
					setAudioDescriptionFile(data);
				})
				.catch((error) => {
					setIsError(true);
					throw error;
				});
		// Download the subtitles file and parse the base64
		const subtitlesUrl = `${video.subtitles.data?.attributes?.url}?v=2`;
		if (subtitlesUrl)
			fetch(subtitlesUrl)
				.then((response) => response.text())
				.then((data) => {
					setSubtitlesBase64(`data:text/vtt;base64,${encode(data)}`);
				})
				.catch((error) => {
					setIsError(true);
					throw error;
				});
	}, [video]);

	return {
		audioDescriptionFile,
		subtitlesBase64,
		isError,
	};
};

export default useVideo;
